import type { BankLimits } from '../../../generated-types';

export enum PaymentLimitsActionType {
    SET_MAX_TRANSACTION_AMOUNT = 'SET_MAX_TRANSACTION_AMOUNT',
    SET_MAX_MONTHLY_TRANSACTION_AMOUNT = 'SET_MAX_MONTHLY_TRANSACTION_AMOUNT',
    SET_BANK_LIMITS = 'SET_BANK_LIMITS',
}

export type PaymentLimitsAction =
    | { type: PaymentLimitsActionType.SET_MAX_TRANSACTION_AMOUNT; payload?: number }
    | { type: PaymentLimitsActionType.SET_MAX_MONTHLY_TRANSACTION_AMOUNT; payload?: number }
    | { type: PaymentLimitsActionType.SET_BANK_LIMITS; payload?: BankLimits };
